import { useCallback } from "react";
import { CouponsApi, useAPIAction } from "melco-shared-logic";

export const useDeleteCoupons = () => {
  const [deleteCoupons] = useAPIAction(
    CouponsApi,
    async (api, id: string) => {
      await api.couponsDelete({ id });

      return {
        successMessages: [{ message: "default" }],
        // data,
      };
    },
    {
      translationPrefix: "coupons.actions.delete",
    }
  );

  return useCallback(
    async (couponIds: string[]) => {
      const successfullyDeleted: string[] = [];

      for (const couponId of couponIds) {
        try {
          await deleteCoupons(couponId);
          successfullyDeleted.push(couponId);
        } catch (e) {
          // error handling is already done in useAPIAction
        }
      }

      return successfullyDeleted;
    },
    [deleteCoupons]
  );
};
